import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgReceivingRedirecting = (props) => /* @__PURE__ */ _jsxs("svg", {
	className: "w-4 h-4 mr-[6px] align-text-top fill-[#484f57]",
	viewBox: "0 0 16 16",
	fill: "#484F57",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [
		/* @__PURE__ */ _jsx("circle", {
			cx: 4.50488,
			cy: 14.5029,
			r: 1.49706
		}),
		/* @__PURE__ */ _jsx("circle", {
			cx: 12.5029,
			cy: 14.5029,
			r: 1.49705
		}),
		/* @__PURE__ */ _jsx("path", { d: "M3.00781 10.0005H14.0008V11.0005C14.0008 11.5528 13.5531 12.0005 13.0008 12.0005H4.00781C3.45553 12.0005 3.00781 11.5528 3.00781 11.0005V10.0005Z" }),
		/* @__PURE__ */ _jsx("rect", {
			x: 12.0098,
			y: 8.00049,
			width: 1.99106,
			height: 2
		}),
		/* @__PURE__ */ _jsx("path", { d: "M0 4.00049H3.99841C4.5507 4.00049 4.99841 4.4482 4.99841 5.00049V6.00049H0V4.00049Z" }),
		/* @__PURE__ */ _jsx("rect", {
			x: 3.00781,
			y: 6,
			width: 1.99109,
			height: 4.00055
		}),
		/* @__PURE__ */ _jsx("path", { d: "M10 2H14V6L12 4L10 2Z" }),
		/* @__PURE__ */ _jsx("rect", {
			x: 12.9424,
			y: 4.47168,
			width: 6.59329,
			height: 2,
			transform: "rotate(135 12.9424 4.47168)"
		})
	]
});
export default SvgReceivingRedirecting;
